import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useReveal, JoinBlock, PageHeader } from '../components/shared';
import { BLOG_POSTS, getPost } from '../blog';

export default function Blog({ slug, go }) {
  useReveal([slug]);
  const post = slug ? getPost(slug) : null;

  // ── Single article view ──
  if (post) {
    return (
      <div className="page active">
        <div className="blog-hero" style={{ backgroundImage: `url(${post.image})` }}>
          <div className="blog-hero-ov" />
          <div className="blog-hero-inner">
            <span className="blog-hero-cat">{post.category}</span>
            <h1 className="blog-hero-title">{post.title}</h1>
            <span className="blog-hero-meta">{post.date} · {post.readTime}</span>
          </div>
        </div>

        <article className="blog-article">
          <button className="blog-back" onClick={() => go('blog')}><ArrowLeft size={15} strokeWidth={2} /> All articles</button>
          <p className="blog-intro rev">{post.intro}</p>
          {post.sections.map((s, i) => (
            <div className="blog-section rev" key={i}>
              <h2 className="blog-h2">{s.h}</h2>
              <p className="blog-p">{s.p}</p>
            </div>
          ))}
          <div className="blog-takeaway rev">
            <span className="blog-takeaway-label">The short version</span>
            <p>{post.takeaway}</p>
          </div>
        </article>

        <JoinBlock
          eyebrow="Never Miss a Post"
          headline="Join our community.<br>Growing tips, first."
          body="Farm gate updates, dahlia tuber first access and growing tips from the paddock — all to our community, before anyone else."
        />
      </div>
    );
  }

  // ── Blog list view ──
  return (
    <div className="page active">
      <PageHeader eyebrow="From the Paddock" title="The Journal" sub="Growing tips, farm notes & local favourites" />
      <div className="blog-grid">
        {BLOG_POSTS.map((p, i) => (
          <article className="blog-card rev" key={p.slug} onClick={() => go('blog', { slug: p.slug })}>
            <div className="blog-card-img bg-photo" style={{ backgroundImage: `url(${p.image})` }}>
              <span className="blog-card-cat">{p.category}</span>
            </div>
            <div className="blog-card-body">
              <span className="blog-card-meta">{p.date} · {p.readTime}</span>
              <h2 className="blog-card-title">{p.title}</h2>
              <p className="blog-card-excerpt">{p.excerpt}</p>
              <span className="blog-card-link">Read the article →</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
